// Modal fragment handler
class ModalFragmentHandler {
  constructor() {
    this.init();
  }

  init() {
    // Check for fragment on page load
    this.checkFragment();
    
    // Listen for hash changes (back/forward navigation)
    window.addEventListener('hashchange', () => {
      this.checkFragment();
    });

    // Initialize all modals
    this.initializeModals();
  }

  checkFragment() {
    const fragment = window.location.hash.substring(1); // Remove the #
    
    if (!fragment) {
      // No fragment, close any open modals
      this.closeAllModals();
      return;
    }

    // Find modal with matching ID
    const modal = document.getElementById(fragment);
    
    if (modal && modal.classList.contains('modal')) {
      this.showModal(modal);
    }
  }

  showModal(modal) {
    modal.style.display = 'block';
    document.body.classList.add('overflow-hidden');
    
    // Focus the close button for accessibility
    const closeButton = modal.querySelector('.modal__close-button');
    if (closeButton) {
      closeButton.focus();
    }
  }

  closeModal(modal) {
    modal.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    // Remove fragment from URL
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  closeAllModals() {
    const modals = document.querySelectorAll('.modal[style*="block"]');
    modals.forEach(modal => {
      modal.style.display = 'none';
    });
    document.body.classList.remove('overflow-hidden');
  }

  initializeModals() {
    const modals = document.querySelectorAll('.modal');

    modals.forEach(modal => {
      const closeButton = modal.querySelector('.modal__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.closeModal(modal);
        });
      }
    });

    document.querySelectorAll('[data-modal-open]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId =
          trigger.getAttribute('data-modal-open') || trigger.getAttribute('aria-controls');
        if (!modalId) return;

        const modal = document.getElementById(modalId);
        if (modal && modal.classList.contains('modal')) {
          this.showModal(modal);
        }
      });
    });

    // Close modal when clicking outside (document level)
    document.addEventListener('click', (e) => {
      const openModal = document.querySelector('.modal[style*="block"]');
      if (!openModal) return;
      if (openModal.contains(e.target)) return;
      if (e.target.closest('[data-modal-open]')) return;
      this.closeModal(openModal);
    });
    
    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.modal[style*="block"]');
        if (openModal) {
          this.closeModal(openModal);
        }
      }
    });
  }
}

// Initialize when DOM is ready (singleton — safe if modal.js is loaded more than once)
function initModalHandler() {
  if (window.modalHandler) return;
  window.modalHandler = new ModalFragmentHandler();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initModalHandler);
} else {
  initModalHandler();
}

// Shopify section select/deselect handlers for theme editor
document.addEventListener('shopify:section:select', function (event) {
  if (event.target.querySelector('[data-modal]')) {
    event.target.querySelector('[data-modal]').classList.add('is-active');
  }
});

document.addEventListener('shopify:section:deselect', function (event) {
  if (event.target.querySelector('[data-modal]')) {
    event.target.querySelector('[data-modal]').classList.remove('is-active');
  }
});